import {useQuery} from '@tanstack/react-query';
import {apiClient} from '@common/http/query-client';
import {BackendResponse} from '@common/http/backend-response/backend-response';
import {useAuth} from '@common/auth/use-auth';
import {Title} from '@app/titles/models/title';
import {Episode} from '@app/titles/models/episode';
import {Lien} from '@app/titles/models/lien';
import {Nzb} from '@app/titles/models/nzb';

interface Response extends BackendResponse {
  report: {
    id: number;
    report: string;
  };
}

export function useCurrentUserReports(item: Lien | Nzb) {
  const {user} = useAuth();
  return useQuery({
    staleTime: 0,
    queryKey: ['report-status', item.id, user?.id],
    queryFn: () => fetchReports(item),
    enabled: false,
  });
}

function fetchReports(item: Title | Episode | Lien | Nzb): Promise<Response> {
  return apiClient
    .get<Response>(`report-status/${item.id}?model_type=${item.model_type}`)
    .then(response => response.data);
}
